var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('i18n',{attrs:{"path":"header.verification","tag":"label"},scopedSlots:_vm._u([{key:"verify",fn:function(){return [_c('a',{on:{"click":_vm.requestVerification}},[_vm._v(" "+_vm._s(_vm.$t('register.success.verify'))+" ")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }